<template>
  <div class="slideBar">
    <div v-show="type != '教材' || identity == 'developer'" @click="seleSlideBar(1)" class="slideBarItem pointer"
      :style="{ backgroundColor: seleSlide == 1 ? 'rgb(137,177,248)' : '' }">
      <img v-if="seleSlide == 1" class="slideBarItem" src="../../../assets/select1.png" alt="" />
      <img v-if="seleSlide != 1" class="slideBarItem" src="../../../assets/noSelect1.png" alt="" />
    </div>
    <div v-show="type != '教材' || identity == 'developer'" @click="seleSlideBar(2)" class="slideBarItem pointer"
      :style="{ backgroundColor: seleSlide == 2 ? 'rgb(137,177,248)' : '' }">
      <img v-if="seleSlide == 2" class="slideBarItem" src="../../../assets/select2.png" alt="" />
      <img v-if="seleSlide != 2" class="slideBarItem" src="../../../assets/noSelect2.png" alt="" />
    </div>
    <div v-show="type != '教材' || identity == 'developer'" @click="seleSlideBar(3)" class="slideBarItem pointer"
      :style="{ backgroundColor: seleSlide == 3 ? 'rgb(137,177,248)' : '' }">
      <img v-if="seleSlide == 3" class="slideBarItem" src="../../../assets/select3.png" alt="" />
      <img v-if="seleSlide != 3" class="slideBarItem" src="../../../assets/noSelect3.png" alt="" />
    </div>
    <div v-show="type != '教材' || identity == 'developer'" @click="seleSlideBar(4)" class="slideBarItem pointer"
      :style="{ backgroundColor: seleSlide == 4 ? 'rgb(137,177,248)' : '' }">
      <img v-if="seleSlide == 4" class="slideBarItem" src="../../../assets/select4.png" alt="" />
      <img v-if="seleSlide != 4" class="slideBarItem" src="../../../assets/noSelect4.png" alt="" />
    </div>
    <div v-show="type != '教材' || identity == 'developer'" @click="seleSlideBar(9)" class="slideBarItem pointer"
      :style="{ backgroundColor: seleSlide == 9 ? 'rgb(137,177,248)' : '' }">
      <img v-if="seleSlide == 9" class="slideBarItem" src="../../../assets/select9.png" alt="" />
      <img v-if="seleSlide != 9" class="slideBarItem" src="../../../assets/noSelect9.png" alt="" />
    </div>
    <div v-show="type == '教材'" @click="seleSlideBar(5)" class="slideBarItem pointer"
      :style="{ backgroundColor: seleSlide == 5 ? 'rgb(137,177,248)' : '' }">
      <img v-if="seleSlide == 5" class="slideBarItem" src="../../../assets/select5.png" alt="" />
      <img v-if="seleSlide != 5" class="slideBarItem" src="../../../assets/noSelect5.png" alt="" />
    </div>
    <div v-show="type == '教材'" @click="seleSlideBar(6)" class="slideBarItem pointer"
      :style="{ backgroundColor: seleSlide == 6 ? 'rgb(137,177,248)' : '' }">
      <img v-if="seleSlide == 6" class="slideBarItem" src="../../../assets/select6.png" alt="" />
      <img v-if="seleSlide != 6" class="slideBarItem" src="../../../assets/noSelect6.png" alt="" />
    </div>
    <div v-show="type != '教材' || identity == 'developer'" @click="seleSlideBar(7)" class="slideBarItem pointer"
      :style="{ backgroundColor: seleSlide == 7 ? 'rgb(137,177,248)' : '' }">
      <img v-if="seleSlide == 7" class="slideBarItem" src="../../../assets/select7.png" alt="" />
      <img v-if="seleSlide != 7" class="slideBarItem" src="../../../assets/noSelect7.png" alt="" />
    </div>
    <div v-show="type != '教材' || identity == 'developer'" @click="seleSlideBar(8)" class="slideBarItem pointer"
      :style="{ backgroundColor: seleSlide == 8 ? 'rgb(137,177,248)' : '' }">
      <img v-if="seleSlide == 8" class="slideBarItem" src="../../../assets/select8.png" alt="" />
      <img v-if="seleSlide != 8" class="slideBarItem" src="../../../assets/noSelect8.png" alt="" />
    </div>
    <!-- 回到首页 -->
    <div class="goBackToHomepage" @click="goBackToHomepage">
      <img class="goBackToHomepageIcon"
        :src="identity == 'super' || identity == 'admin' ? require('../../../assets/goBackHomepage.png') : require('../../../assets/goBackToMySpaceIcon.png')" />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      identity: "", // 登录身份
      type: "",
      seleSlide: 1,
    };
  },
  created() {
    // 获取登录身份
    if (this.$store.state.loginRecord) {
      this.identity = this.$store.state.loginRecord.data.datas.identity;
    }
    this.type = this.$route.query.type;
    let that = this;
    if (this.type == "教材" && this.identity != "developer") {
      this.$router.push("/textbookEditor");
      this.seleSlide = 5;
    }
  },
  methods: {
    // 选择slidebar
    seleSlideBar(index) {
      this.seleSlide = index;
      if (index == 1) {
        this.$router.push("/courseInformation");
      } else if (index == 2) {
        this.$router.push("/classManagement");
      } else if (index == 3) {
        this.$router.push("/resourceManagement");
      } else if (index == 4) {
        this.$router.push("/courseTeaching");
      } else if (index == 5) {
        this.$router.push("/textbookEditor");
      } else if (index == 6) {
        this.$router.push("/AREditing");
      } else if (index == 7) {
        this.$router.push("/studentStatistics");
      } else if (index == 8) {
        this.$router.push("/viewPoints");
      } else if (index == 9) {
        this.$router.push("/onlineExamination");
      }
    },
    // 回到首页
    goBackToHomepage() {
      if (this.identity == "super" || this.identity == "admin") {
        this.$router.push("/guidePage");
      } else {
        this.$router.push("/homepage");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
::-webkit-scrollbar {
  /*隐藏滚轮*/
  display: none;
}

.flex {
  display: flex;
}

.align {
  align-items: center;
}

.justify {
  justify-content: center;
}

.spaceBetween {
  justify-content: space-between;
}

img {
  display: block;
}

.slideBar {
  position: relative;
  width: 100px;
  height: calc(100vh - 179px);
  background: #ced1da;
  overflow: auto;
}

// 课程信息
.courseInformation {
  width: 100%;
  height: 109px;
  border-bottom: 1px solid #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
}

.courseInformation:hover {
  background-color: rgba($color: #000000, $alpha: 0.4);
  cursor: pointer;
}

// 班级管理
.classManagement {
  width: 100%;
  height: 109px;
  border-bottom: 1px solid #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
}

.classManagement:hover {
  background-color: rgba($color: #000000, $alpha: 0.4);
  cursor: pointer;
}

// 资源管理
.resourceManagement {
  width: 100%;
  height: 109px;
  border-bottom: 1px solid #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
}

.resourceManagement:hover {
  background-color: rgba($color: #000000, $alpha: 0.4);
  cursor: pointer;
}

// 课程教学
.courseTeaching {
  width: 100%;
  height: 109px;
  border-bottom: 1px solid #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
}

.courseTeaching:hover {
  background-color: rgba($color: #000000, $alpha: 0.4);
  cursor: pointer;
}

.textbookEditorBox {
  width: 100%;
  height: 109px;
  border-bottom: 1px solid #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
}

.textbookEditorBox:hover {
  background-color: rgba($color: #000000, $alpha: 0.4);
  cursor: pointer;
}

.AReditBox {
  width: 100%;
  height: 109px;
  border-bottom: 1px solid #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
}

.AReditBox:hover {
  background-color: rgba($color: #000000, $alpha: 0.4);
  cursor: pointer;
}

// 学情统计
.studentStatistics {
  width: 100%;
  height: 109px;
  border-bottom: 1px solid #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
}

.studentStatistics:hover {
  background-color: rgba($color: #000000, $alpha: 0.4);
  cursor: pointer;
}

// 积分查看
.viewPoints {
  width: 100%;
  height: 109px;
  border-bottom: 1px solid #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
}

.viewPoints:hover {
  background-color: rgba($color: #000000, $alpha: 0.4);
  cursor: pointer;
}

// 回到首页
.goBackToHomepage {
  position: fixed;
  bottom: 0;
  width: 100px;
  height: 109px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #89b1f8;
}

.goBackToHomepage:hover {
  cursor: pointer;
}

.courseInformationIcon {
  width: 71px;
  height: 51px;
}

.classManagementIcon {
  width: 71px;
  height: 52px;
}

.resourceManagementIcon {
  width: 89px;
  height: 52px;
}

.courseTeachingIcon {
  width: 71px;
  height: 56px;
}

.textbookEditor {
  width: 71px;
  height: 53px;
}

.ARedit {
  width: 61px;
  height: 56px;
}

.studentStatisticsIcon {
  width: 71px;
  height: 57px;
}

.viewPointsIcon {
  width: 71px;
  height: 57px;
}

.goBackToHomepageIcon {
  width: 70px;
  height: 57px;
}

.slideBarItem {
  width: 100px;
  height: 100px;
  border-bottom: 1px solid #ffffff;
}
</style>
